import { FormikFileInput, type FormikProps } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import type { BranchCreationInput } from '../types'
import { validate } from './helpers'

type Props = {
  state: FormikProps<BranchCreationInput>
}

export const DataIngestionStep = ({ state: { values } }: Props) => {
  const translate = useTranslate()

  return (
    <>
      {values.category === 'main' && (
        <p>
          {translate('branchCreationWizard.dataIngestionStep.description', {
            category: values.category,
          })}
        </p>
      )}
      <p>
        {values.category === 'main'
          ? translate('branchCreationWizard.dataIngestionStep.emptyInfo')
          : translate('branchCreationWizard.dataIngestionStep.baseInfo')}
      </p>
      <FormikFileInput
        label={translate('branchCreationForm.fileSelector.label')}
        name={validate('importFromFile')}
        accept=".json"
        multiple={false}
      />
    </>
  )
}
